import axiosInstance from "./baseUrl";

export const fetchAllNotificationsService = (params: any) =>
  axiosInstance.get("/v1/notifications", { params });

export const sendSingleNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/send-push", data);

export const sendBulkNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/send-bulk-push", data);

// WhatsApp Notification Services
export const sendWhatsAppSingleNotificationService = (data: any) =>
  axiosInstance.post("/v1/termi/send-template", data);

export const sendWhatsAppBulkNotificationService = (data: any) =>
  axiosInstance.post("/v1/termi/send-template-bulk", data);

// Promo Notification Service (for anonymous installs)
export const sendPromoNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/anonymous/send-promo", data, {
    timeout: 60000, // 60s - this endpoint can be slow when targeting all anonymous installs
  });

// ── Scheduled / Automated Notification Services ──

export const createScheduledNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/scheduled", data);

export const getScheduledNotificationsService = () =>
  axiosInstance.get("/v1/notifications/scheduled");

export const getScheduledNotificationByIdService = (id: number) =>
  axiosInstance.get(`/v1/notifications/scheduled/${id}`);

export const updateScheduledNotificationService = (id: number, data: any) =>
  axiosInstance.put(`/v1/notifications/scheduled/${id}`, data);

export const deleteScheduledNotificationService = (id: number) =>
  axiosInstance.delete(`/v1/notifications/scheduled/${id}`);

export const toggleScheduledNotificationService = (id: number) =>
  axiosInstance.post(`/v1/notifications/scheduled/${id}/toggle`);

export const sendScheduledNowService = (id: number) =>
  axiosInstance.post(`/v1/notifications/scheduled/${id}/send-now`);

export const dryRunScheduledNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/scheduled/dry-run", data);
